import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import Priority from '../../components/Ticket/PriorityDetail/Priority'
export default class PriorityDetailPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <Priority />
            </div>
        )
    }
}
